import React from "react";
import { Grid2 } from "@mui/material";
import CitiesAutocomplete from "./CitiesAutocomplete";
import axios from "axios";
const ManageDoctors = ({ control, disabled }) => {
  const [doctors, setDoctors] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [query, setQuery] = React.useState("");
  const API_ENDPOINT = process.env.REACT_APP_API_URL;
  // Fetch cities based on search query
  React.useEffect(() => {
    if (!doctors) {
      fetchDoctors();
    }
  }, []);

  const fetchDoctors = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_ENDPOINT}/api/doctors`);
      // console.log("response = ", res);

      setDoctors(
        res?.data?.map((item) => ({
          label: `${item.name}`,
          id: item._id,
        }))
      );
    } catch (error) {
      console.error("Error fetching doctors:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <CitiesAutocomplete
          control={control}
          fieldname="assignedTo"
          options={doctors || []}
          label="Assigned doctor"
          required
          disabled={disabled}
          loading={loading}
          onSearch={setQuery} // Pass the query setter
          query={query}
        />
      </Grid2>
      {/* <FormDynamicAutocomplete
        control={control}
        fieldname="assignedTo"
        options={doctors || []}
        label="Assigned Doctor"
        required
        // disabled={true}
        loading={loading}
        onSearch={setQuery} // Pass the query setter
        query={query}
    
    /> */}
    </>
  );
};

export default ManageDoctors;
